import React, { FC } from "react";

import * as Styled from "./content-item-row-data.styled";
import { IContentItemRowInput } from "./content-item-row-data.types";

export const ContentItemRowData: FC<IContentItemRowInput> = ({
  rowHeading,
  data,
}) => (
  <Styled.UL>
    {data.map((string, index) => (
      <Styled.LI key={`${rowHeading}-${index}`}>{string}</Styled.LI>
    ))}
  </Styled.UL>
);
